<fa-icon [icon]="['fas', 'circle-notch']"
         [animation]="'spin'"
         size="2x"
         class="text-secondary"></fa-icon>